export default "/profile/images/instruction-1-en.webp?53deca5e217f0df9adcfa4d7c40c61e7";